<template>
    <!--弹窗-->
    <el-dialog
        width="650px"
        :title="title"
        :visible.sync="visible"
        :before-close="handleClose"
        top="5vh"
        append-to-body
    >
        <el-form ref="formData" :model="formData" label-width="230px" :rules="rules">

            <el-form-item label="根类目：" prop="keepa_category_id">
                <el-cascader :options="options" :props="{multiple: false}" v-model="formData.keepa_category_id"
                             clearable></el-cascader>
            </el-form-item>

        </el-form>
        <el-row style="margin-top:17px; ">
            <el-button
                style="float:right;margin-left:6px;"
                size="mini"
                type="danger"
                plain
                @click="handleClose()"
            >取 消
            </el-button
            >
            <el-button
                style="float:right"
                size="mini"
                type="primary"
                @click="submitForm()"
                :loading="loading"
            >确定
            </el-button
            >
        </el-row>
    </el-dialog>
</template>
<script>
import * as api from '@/api/advAnalys/advAnalys.js'
import {keepa_keepa_root_category_index} from '@/api/advAnalys/advAnalys.js'

export default {
    components: {},
    data() {
        return {
            loading: false,
            options: [],

            rules: {
                keepa_category_id: [
                    {
                        required: true,
                        message: '请选择根类目',
                        trigger: 'blur'
                    },
                ],
            },
            formData: {
                keepa_category_id: [],
            }
        }
    },
    props: {
        visible: {
            type: Boolean,
            default: false
        },
        title: {
            type: String,
            default: ''
        },
    },
    watch: {
        visible: {
            handler(val) {
                val && this.getCategoryList()
            }
        },
    },

    methods: {
        getCategoryList() {
            this.loading = true
            api.keepa_keepa_root_category_index().then(res => {
                if (res.code === 0) {
                    let stateArr = (res.data || []).map(item => item.state)
                    stateArr = Array.from(new Set(stateArr))
                    const us_arr = this.$common.us_arr_normal.filter(item => stateArr.includes(item.us))

                    let options = []
                    for (const item of us_arr) {
                        let obj = {value: item.us, label: item.title, children: []}
                        options.push(obj)
                        for (const childItem of (res.data || [])) {
                            if (item.us == childItem.state) {
                                obj.children.push({
                                    value: childItem.id,
                                    label: childItem.name,
                                })
                            }
                        }
                    }
                    this.options = options
                    console.log('options:', options)
                } else {
                    this.$message({type: 'error', message: res.message})
                }
            }).finally(() => {
                this.loading = false
            })
        },
        // 保存信息
        submitForm() {
            this.$refs['formData'].validate(valid => {
                if (valid) {
                    const id = this.formData.keepa_category_id[1]

                    api.keepa_keepa_category_rank_statistics_task_list_add({keepa_category_id: id}).then(res => {
                        this.loading = false
                        if (res.code === 0) {
                            this.$message({message: '添加成功', type: 'success'})
                            this.handleClose(true)
                        } else {
                            this.$message({type: 'error', message: res.message})
                        }
                    }).catch(() => {
                        this.loading = false
                        this.$message({
                            type: 'error',
                            message: '网络出现问题，请刷新页面！'
                        })
                    })
                } else {
                    this.loading = false
                    this.$message({
                        type: 'error',
                        message: '请填写相应内容！'
                    })
                }
            })
        },
        // 关闭弹窗
        handleClose(isshow = false) {
            this.formData = {
                keepa_category_id: [],
            }
            this.$refs['formData'].resetFields()
            this.loading = false
            this.$emit('close-callback', isshow)
        },
    }
}
</script>
<style type="text/scss" lang="scss" scoped>
.content {
    display: flex;
    justify-content: space-between;
    border-top: 1px solid #cecfd1;
    font-size: 12px;
    color: #000;

    .shu {
        border-right: 1px solid #cecfd1;
    }

    .content-div {
        width: 50%;
        padding: 25px 20px;
    }

    .content-buttom {
        display: flex;
        justify-content: space-between;
        border-bottom: 1px solid #cecfd1;
        padding-bottom: 8px;
        margin-bottom: 10px;
    }

    .content-buttom-txet {
        color: rgb(57, 187, 252);
        cursor: pointer;
    }

    .content-data {
        width: 100%;
        height: 230px;
        overflow: auto;

        .content-list {
            display: flex;
            justify-content: space-between;
            align-items: center;
            margin: 10px 0;

            .cha {
                cursor: pointer;
                font-size: 15px;
                color: rgb(158, 192, 209);
                margin: 0 10px 0 12px;
            }
        }
    }

    /deep/ .content-data::-webkit-scrollbar {
        width: 3px;
        height: 5px;
        border-radius: 15px;
        -webkit-border-radius: 15px;
    }

    /deep/ .content-data::-webkit-scrollbar-track-piece {
        background-color: #ffff;
        border-radius: 15px;
        -webkit-border-radius: 15px;
    }

    /deep/ .content-data::-webkit-scrollbar-thumb:vertical {
        height: 5px;
        background-color: rgba(144, 147, 153, 0.5);
        border-radius: 15px;
        -webkit-border-radius: 15px;
    }

    /deep/ .content-data::-webkit-scrollbar-thumb:horizontal {
        width: 3px;
        background-color: rgba(144, 147, 153, 0.5);
        border-radius: 15px;
        -webkit-border-radius: 15px;
    }
}

.media-txt {
    font-size: 15px;
    color: #6a6c6f;
    font-weight: 600;
    margin-bottom: 8px;
}

/deep/ .el-dialog__body {
    padding: 0px 20px 20px 20px !important;
}

/deep/ .el-form-item {
    margin-bottom: 12px !important;
}
</style>
